import AddVesselNominationContainer from "@features/vessel-nomination/add/components/AddVesselNominationContainer";
import Documents from "@features/vessel-nomination/add/components/documents/Documents";
import PreArrivalQuestionnaire from "@features/vessel-nomination/add/components/pre-arrival-questionnaire/PreArrivalQuestionnaire";
import {
  DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION,
  FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION,
} from "@features/vessel-nomination/constants";
import DryBulkAddVesselNominationPage from "@features/vessel-nomination/dry-bulk/add/DryBulkAddVesselNominationPage";
import DryBulkNominationDetailsPage from "@features/vessel-nomination/dry-bulk/add/DryBulkNominationDetailsPage";
import NominationStatusDocuments from "@features/vessel-nomination/nomination-details/steps/Documents";
import NominationStatusPAQ from "@features/vessel-nomination/nomination-details/steps/PAQ";
import VesselNominationDetails from "@features/vessel-nomination/nomination-details/VesselNominationDetails";
import PreNominationRequest from "@features/vessel-nomination/pre-nomination-request/PreNominationRequest";
import VesselNominationScanPage from "@features/vessel-nomination/vessel-scan/VesselNominationScanPage";
import VesselNominationScanResults from "@features/vessel-nomination/vessel-scan/VesselNominationScanResults";
import VesselNomination from "@features/vessel-nomination/VesselNomination";
import VesselNominationPage from "@pages/vessel-nomination/VesselNominationPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getVesselNominationRoutes = (): AppRoute => ({
  path: paths.vesselNomination.index,
  protected: true,
  requiredPermissions: [
    FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION,
    DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION,
  ],
  element: <VesselNominationPage />,
  children: [
    { index: true, element: <VesselNomination /> },
    {
      path: paths.vesselNomination.details,
      element: <VesselNominationDetails />,
      children: [
        { index: true, redirectTo: paths.vesselNomination.paq },
        {
          path: paths.vesselNomination.paq,
          element: <NominationStatusPAQ />,
        },
        {
          path: paths.vesselNomination.documents,
          element: <NominationStatusDocuments />,
        },
      ],
    },
    {
      path: paths.vesselNomination.vesselScan,
      protected: true,
      requiredPermissions: [
        FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION,
        DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION,
      ],
      element: <VesselNominationScanPage />,
    },
    {
      path: paths.vesselNomination.scanResults,
      protected: true,
      requiredPermissions: [
        FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION,
        DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION,
      ],
      element: <VesselNominationScanResults />,
    },
    {
      path: paths.vesselNomination.addDryBulk,
      protected: true,
      requiredPermissions: [DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <DryBulkAddVesselNominationPage />,
    },
    {
      path: paths.vesselNomination.addDryBulkDraft,
      protected: true,
      requiredPermissions: [DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <DryBulkAddVesselNominationPage />,
    },
    {
      path: paths.vesselNomination.editDryBulk,
      protected: true,
      requiredPermissions: [DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <DryBulkAddVesselNominationPage />,
    },
    {
      path: paths.vesselNomination.dryBulkDetails,
      protected: true,
      requiredPermissions: [DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <DryBulkNominationDetailsPage />,
    },
    {
      path: paths.vesselNomination.preNominationRequest,
      protected: true,
      requiredPermissions: [FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <PreNominationRequest />,
    },
    {
      path: paths.vesselNomination.add,
      protected: true,
      requiredPermissions: [FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION],
      element: <AddVesselNominationContainer />,
      children: [
        { index: true, redirectTo: paths.vesselNomination.preArrivalQuestionnaire },
        {
          path: paths.vesselNomination.preArrivalQuestionnaire,
          element: <PreArrivalQuestionnaire />,
        },
        {
          path: paths.vesselNomination.documents,
          element: <Documents />,
        },
      ],
    },
  ],
});
